import styled from 'styled-components';

/**
 * Standard card on surface background with hover elevation effect.
 * Used across features for content cards (license cards, diagnostic cards, etc.)
 *
 * Supports both `md` (default) and `lg` padding via the $padding prop. Pass
 * `$static` for non-interactive containers (e.g. settings panels) so the card
 * does not lift/elevate on hover.
 */
export const SurfaceCard = styled.div<{ $padding?: 'md' | 'lg'; $borderless?: boolean; $static?: boolean }>`
    padding: ${(p): string => `var(--mantine-spacing-${p.$padding ?? 'lg'})`};
    background: var(--bm-color-card);
    border: ${(p): string => (p.$borderless ? 'none' : '1px solid var(--bm-color-border)')};
    border-radius: var(--bm-radius);
    box-shadow: var(--bm-card-shadow);
    display: flex;
    flex-direction: column;
    transition:
        box-shadow 250ms ease,
        transform 250ms ease;
    cursor: default;

    &:hover {
        box-shadow: ${(p): string => (p.$static ? 'var(--bm-card-shadow)' : 'var(--bm-card-shadow-hover)')};
        transform: ${(p): string => (p.$static ? 'none' : 'translateY(-2px)')};
    }
`;
